'use client';

/**
 * Root-level SlotsProvider so all route segments (including editor) are under the same context.
 * Prevents "useSlots must be used within SlotsProvider" when editor or other modules load in any chunk order.
 */

import { SlotsProvider } from '@korvo/shell/SlotsContext';

export function SlotsProviderRoot({ children }: { children: React.ReactNode }) {
  return <SlotsProvider>{children}</SlotsProvider>;
}
